import {
  useCheckingProfile,
  useITVCompanyCode,
  useITVTenant,
  useMonthTarget,
  useOltType,
} from "@/api/master-param";
import { FieldInput } from "@/components/form/field-input";
import { FieldSelect } from "@/components/form/field-select";
import { FieldTextarea } from "@/components/form/field-textarea";

interface APDFormFieldsProps {
  isDisabled?: boolean;
}

export function APDFormFields({ isDisabled = false }: APDFormFieldsProps) {
  const { data: itv_olt_type } = useOltType();
  const oltTypeOptions = itv_olt_type?.content.map((oltType) => ({
    label: oltType.value,
    value: oltType?.paramTag,
  }));

  const { data: itv_tenant } = useITVTenant();
  const itvTenantOptions = itv_tenant?.content.map((itvTenant) => ({
    label: itvTenant.value,
    value: itvTenant.value,
  }));

  const { data: itv_companyCode } = useITVCompanyCode();
  const itvCompanyCodeOptions = itv_companyCode?.content.map(
    (itvCompanyCode) => ({
      label: itvCompanyCode.paramTag,
      value: itvCompanyCode.paramTag,
    }),
  );

  const { data: itv_monthTarget } = useMonthTarget();
  const itvMonthTargetOptions = itv_monthTarget?.content
    .map((itvMonthTarget) => ({
      label: itvMonthTarget.value,
      value: itvMonthTarget.paramTag,
    }))
    .sort((a, b) => Number(a.value) - Number(b.value));

  const { data: profileName } = useCheckingProfile();
  const profileNameOptions = profileName?.content.map((profileName) => ({
    label: profileName.profileName,
    value: profileName.profileName,
  }));

  return (
    <>
      <FieldInput
        name="cityTown"
        label="City Town"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="clusterId"
        label="Cluster ID"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="hpPermit"
        label="HP Permit"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="hpDesign"
        label="HP Design"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="suffixPermit"
        label="Suffix Permit"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="fdtId"
        label="FDT ID"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="drawingIdApd"
        label="Drawing ID APD"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldSelect
        name="oltType"
        label="OLT Type"
        options={oltTypeOptions ?? []}
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="oltIdaction"
        label="OLT ID"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="combineStatus"
        label="Combine Status"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="latitude"
        label="Latitude"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="longitude"
        label="Longitude"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="rollOutType"
        label="Roll-Out Type"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldSelect
        name="profileName"
        label="Profile Name"
        options={profileNameOptions ?? []}
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldSelect
        name="tenantName"
        label="Tenant Name"
        options={itvTenantOptions ?? []}
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldSelect
        name="vendor"
        label="Vendor"
        options={itvCompanyCodeOptions ?? []}
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldSelect
        name="monthTarget"
        label="Month Target"
        options={itvMonthTargetOptions ?? []}
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldInput
        name="yearTarget"
        label="Year Target"
        type="number"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
      <FieldTextarea
        name="projectName"
        label="Project Name"
        isDisabled={isDisabled}
        hasRequiredAsterisk
      />
    </>
  );
}
